import React, { version } from 'react';
import { Link } from '../../../env';
const Downloads = () => {
    const Downloads = [
        {
            title: 'Tuning and Remap Software',
            description: `Optimize your vehicle's performance with our advanced Tuning and Remap Software, designed to enhance power and efficiency seamlessly`,
            link: 'https://c695764.parspack.net/c695764/IRSystem_Software/downloads/IRSystemRemapV6033.exe',
            version: 'V6.0.33',
            img: `${Link}assets/JPEG/Download_Remap_Img.jpg`
        },
        {
            title: 'Advanced ECU Repair Software',
            description: `Streamline and enhance your ECU diagnostics and repairs with our sophisticated ECU Repair Software, tailored for precision and efficiency`,
            link: 'https://c695764.parspack.net/c695764/IRSystem_Software/downloads/IRSystemEcu_V320.exe',
            version: '',
            img: `${Link}assets/JPEG/ecufixing.webp`
        },
        {
            title: 'Remote Software : ALPEMIX',
            description: 'Access seamless support with our use of industry-standard remote software, ensuring quick and reliable assistance for our customers.',
            link: 'https://c695764.parspack.net/c695764/IRSystem_Software/downloads/ALPEMIX.exe',
            version: '',
            img: `${Link}/assets/Icons/Alpemix.png`
        },
        {
            title: 'Remote Software : AnyDesk',
            description: 'Access seamless support with our use of industry-standard remote software, ensuring quick and reliable assistance for our customers.',
            link: 'https://c695764.parspack.net/c695764/IRSystem_Software/downloads/AnyDesk.exe',
            version: '',
            img: `${Link}/assets/Icons/AnyDesk.png`
        },
        {
            title: 'Video Driver',
            description: `This software expertly manages and facilitates the rendering of videos`,
            link: 'https://c695764.parspack.net/c695764/IRSystem_Software/downloads/Xvid-1.3.5-20171208.exe',
            version: '',
            img: `${Link}/assets/Icons/videoDriver.png`
        }
    ]
    return (
        <div className='w-full'>
            <div className='w-full h-[300px] 2xl:h-[400px] my-[100px]'>
                <div className='w-full h-full relative flex justify-center bg-[#212f3c] opacity-[0.9]'>
                    <div className='container h-full relative'>
                        <div className='w-full h-full absolute top-0 left-0 z-0'></div>
                        <div className='w-full h-full absolute top-0 left-0 z-10 flex justify-between'>
                            <div className='w-[50%] h-full flex justify-center'>
                                <div className='w-[80%]'>
                                    <div className='w-full text-white mt-9 xl:mt-12 2xl:mt-[70px]'>
                                        <h1 className='poppins-medium text-2xl 2xl:text-3xl'>Pay with Bitcoin</h1>
                                    </div>
                                    <div className='text-white poppins-medium text-md mt-5 text-justify 2xl:text-xl'>
                                        {`
                                        Upgrade your car's performance by purchasing our ECU remapping and tuning software 
                                        exclusively with Bitcoin. Simple, secure, and direct—our Bitcoin payment process 
                                        ensures a hassle-free transaction, letting you quickly boost your vehicle’s 
                                        capabilities. Start your tuning journey today and unlock enhanced performance with 
                                        just a few clicks
                                        `}
                                    </div>
                                </div>
                            </div>
                            <div className='w-[50%] h-full flex justify-center 2xl:justify-end items-center'>
                                <div className='w-[400px] h-[400px] 2xl:w-[500px] 2xl:h-[500px] bg-white rounded-full relative'>
                                    <img src={`${Link}/assets/JPEG/bitcoin-wallpaper.jpg`} alt='Payment Integration' fill className='w-full h-full rounded-full p-1' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id='download' className='w-full my-5 border-2 border-transparent'></div>
            <div className='w-full flex justify-center mt-[120px] mb-[100px]'>
                <div className='container'>
                    <div className='w-full grid grid-cols-2 gap-5 px-9 xl:px-10 2xl:px-20'>
                        {
                            Downloads.map((item, index) => (
                                <div key={index} className='w-full flex justify-center'>
                                    <div className='w-full h-[240px] rounded-lg border-[1px] border-[rgba(0,0,0,0.4)]'>
                                        <div className='w-full h-full flex'>
                                            <div className='w-[40%] 2xl:w-[30%] h-full flex justify-center items-center'>
                                                <div className='w-full h-full flex  justify-center p-5 items-center relative rounded-full Rotate-animation'>
                                                    <div className={`rounded-xl flex justify-center items-center w-[200px] h-[160px] border-[1px] border-[gray]`}>
                                                        <img src={item.img} alt='Payment Integration' className='bg-cover w-full h-full rounded-xl' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='w-[60%] 2xl:w-[70%] h-full relative'>
                                                <div className='w-full'>
                                                    <h1 className='text-black text-lg 2x:text-2xl mt-7 poppins-medium'>{item.title}</h1>
                                                </div>
                                                <div className='w-full mt-2 2xl:mt-0'>
                                                    <h1 className='w-[90%] text-black text-sm 2xl:text-lg mt-1 poppins-medium text-justify'>
                                                        {item.description.slice(0, 113)}...
                                                    </h1>
                                                </div>
                                                <div className='w-full absolute bottom-5 xl:bottom-5 2xl:bottom-10'>
                                                    <a href={item.link}>
                                                        <button className='mt-3 hover:bg-[#34495e]  bg-[#2980b9] text-white px-3 py-2 rounded-lg poppins-regular'>
                                                            Downloads  {item.version}
                                                        </button>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Downloads;